export const BASE_URL = `${process.env.BASE_URL && process.env.BASE_URL.includes('localhost') ? 'http' : 'https'}://${
  process.env.BASE_URL
}`;

export const SPEC_URL = `${BASE_URL}/v3/timescale`;
